import { render, staticRenderFns } from "./ChangeCompanySales.vue?vue&type=template&id=666e0512&"
import script from "./ChangeCompanySales.vue?vue&type=script&lang=js&"
export * from "./ChangeCompanySales.vue?vue&type=script&lang=js&"
import style0 from "./ChangeCompanySales.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports